import { useContext } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import AuthContext from "../context/AuthContext";

import GoogleSocialAuth from './auth/GoogleSocialAuth';
import FacebookSocialAuth from './auth/FacebookSocialAuth';
import AuthLayout, { TRUE_MUTED, primaryButtonSx, strongLinkStyle } from './auth/AuthLayout';

import { Link } from 'react-router-dom'

// GoogleSocialAuth calls useGoogleLogin(), which throws unless App mounted a
// GoogleOAuthProvider — and App only does that when a client ID is configured.
const hasSocialAuth = !!process.env.REACT_APP_GOOGLE_CLIENT_ID;

const Register = () => {
  const { registerUser } = useContext(AuthContext);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const username = String(data.get('email'))
    let emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailRegex.test(username)) {
      alert("Ingresa un correo válido");
      return;
    }
    const password = data.get('password')
    const confirmPassword = data.get('confirm_password')
    registerUser(username, password, confirmPassword);
  };

  return (
    <AuthLayout title="Crea tu cuenta" subtitle="Tu correo electrónico será tu usuario">
      <Box component="form" noValidate onSubmit={handleSubmit}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label="Correo electrónico"
          name="email"
          autoComplete="email"
          autoFocus
          size="small"
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Contraseña"
          type="password"
          id="password"
          autoComplete="new-password"
          size="small"
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="confirm_password"
          label="Confirmar contraseña"
          type="password"
          id="confirm_password"
          autoComplete="new-password"
          size="small"
          sx={{ mb: 3 }}
        />

        <Button type="submit" fullWidth variant="contained" sx={primaryButtonSx}>
          Crear cuenta
        </Button>

        {hasSocialAuth && (
          <>
            <Divider sx={{ my: 3, color: '#A3A39B', fontSize: '0.8rem' }}>o continúa con</Divider>
            <Stack direction="row" spacing={2} sx={{ justifyContent: 'center', mb: 3 }}>
              <GoogleSocialAuth />
              <FacebookSocialAuth />
            </Stack>
          </>
        )}

        <Typography variant="body2" sx={{ textAlign: 'center', color: TRUE_MUTED, fontFamily: 'Inter, sans-serif', mt: hasSocialAuth ? 0 : 3 }}>
          ¿Ya tienes una cuenta?{' '}
          <Link to="/login" style={strongLinkStyle}>
            Ingresa
          </Link>
        </Typography>
      </Box>
    </AuthLayout>
  );
}

export default Register;
